import Link from "next/link";

export default function Breadcrumbs({ items = [] }) {
    return (
        <nav className="text-xs text-gray-500 mb-8" aria-label="Breadcrumb">
            <ol className="flex flex-wrap items-center gap-1">
                {items.map((item, idx) => (
                    <li
                        key={`${item.href || ""}-${item.label || ""}-${idx}`}
                        className="flex items-center"
                    >
                        {item.href ? (
                            <Link
                                href={item.href}
                                className="hover:underline transition"
                            >
                                {item.label}
                            </Link>
                        ) : (
                            <span className="font-semibold text-gray-700">
                                {item.label}
                            </span>
                        )}
                        {idx < items.length - 1 && (
                            <span className="mx-2 text-gray-400">/</span>
                        )}
                    </li>
                ))}
            </ol>
        </nav>
    );
}
